import { Component , OnInit } from '@angular/core';
import { faCompass } from '@fortawesome/free-solid-svg-icons';
import { DashboardService } from '../dashboard/dashboard.service';


@Component({
	selector: 'page-404',
  templateUrl: './page-not-found.component.html'
})
export class PageNotFoundComponent  implements OnInit{


  constructor(private dashboardService : DashboardService) { }

  faCompass = faCompass;

  ngOnInit(): void {

  }

 }